import { ArrowRightIcon, BusIcon, UserIcon } from "assets/icons";
import { BusCard, Table } from "components";

function AvailableBuses({ routes }) {
  const columns = [
    {
      selector: () => <img src={"/images/logo.jpeg"} className="h-12" />,
    },
    {
      selector: (row) => (
        <div className="flex items-center">
          <span className="text-primary-700 mr-4">
            <BusIcon />
          </span>
          <div className="flex items-center text-base font-semibold text-[#263238]">
            <span>{row.board_city_name}</span>
            <span className="h-[18px] w-[18px] text-[#858585] px-2">
              <ArrowRightIcon />
            </span>

            <span>{row.drop_city_name}</span>
          </div>
        </div>
      ),
    },
    {
      selector: (row) => (
        <div className="flex items-center">
          <span className="text-primary-700 mr-4">
            <UserIcon />
          </span>
          <div className="flex items-center text-base font-semibold text-[#263238]">
            {`RM${row.min_ticket_price} - RM${row.max_ticket_price}`}
          </div>
        </div>
      ),
    },
    {
      selector: (row) => (
        <button className="text-sm text-white py-2 px-4 bg-primary-700 rounded-[4px]">
          Select Seat
        </button>
      ),
      maxWidth: "160px",
    },
  ];

  if (!routes?.length) {
    return null;
  }
  return (
    <div className="w-full flex flex-col">
      <div className="text-lg text-[#112211] font-semibold mb-1 sm:mb-3">
        Available Bus
      </div>
      <div className="text-sm sm:text-base text-[#112211] mb-4 sm:mb-6">
        Select a ticket type
      </div>
      <div className="bg-white px-6 hidden lg:block">
        <Table columns={columns} data={routes} noTableHead={true} />
      </div>

      <div className="w-full flex flex-col gap-3 lg:hidden">
        {routes.map((item, index) => (
          <BusCard data={item} key={index} />
        ))}
      </div>
    </div>
  );
}

export default AvailableBuses;
